import { useTranslation } from 'react-i18next';

interface PopularPlacesProps {
  onPlaceSelect: (lat: number, lng: number, city: string, country?: string) => void;
}

const POPULAR_PLACES = [
  { name: 'Helsinki', lat: 60.1699, lng: 24.9384, country: 'Finland' },
  { name: 'Tampere', lat: 61.4978, lng: 23.7610, country: 'Finland' },
  { name: 'Turku', lat: 60.4518, lng: 22.2666, country: 'Finland' },
  { name: 'Oulu', lat: 65.0121, lng: 25.4651, country: 'Finland' },
  { name: 'Jyväskylä', lat: 62.2415, lng: 25.7209, country: 'Finland' },
  { name: 'Lahti', lat: 60.9827, lng: 25.6612, country: 'Finland' },
  { name: 'Kuopio', lat: 62.8924, lng: 27.6770, country: 'Finland' },
  { name: 'Pori', lat: 61.4851, lng: 21.7974, country: 'Finland' },
];

export function PopularPlaces({ onPlaceSelect }: PopularPlacesProps) {
  const { t } = useTranslation();

  return (
    <div className="mt-4">
      <h3 className="text-sm font-semibold text-foreground mb-3">{t('search.popularPlaces')}</h3>
      <div className="flex gap-2 overflow-x-auto lg:overflow-x-visible lg:flex-wrap pb-2 scrollbar-hide">
        {POPULAR_PLACES.map((place) => (
          <button
            key={place.name}
            onClick={() => onPlaceSelect(place.lat, place.lng, place.name, t(`countries.${place.country}`))}
            className="flex-shrink-0 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-colors whitespace-nowrap"
          >
            {place.name}
          </button>
        ))}
      </div>
    </div>
  );
}

